import Vue from 'vue'
import Vuex from 'vuex'
import Couchdb from 'src/services/Couchdb'
import CouchdbClass from 'src/services/CouchdbClass'
import Users from 'src/vuex/modules/users'
import Events from 'src/vuex/modules/events'
import Customers from 'src/vuex/modules/customers'
import Project from 'src/vuex/modules/project'
import Manufacturers from 'src/vuex/modules/manufacturers'
import Stocks from 'src/vuex/modules/stocks'
import Lamps from 'src/vuex/modules/lamps'
import Tickets from 'src/vuex/modules/tickets'
import States from 'src/vuex/modules/states'
import Roles from 'src/vuex/modules/roles'
import Winners from 'src/vuex/modules/winners'
import Surveys from 'src/vuex/modules/surveys'
import Ranking from 'src/vuex/modules/ranking'
import Tags from 'src/vuex/modules/tags'
import Api from 'src/vuex/modules/api'
import categories from 'src/vuex/modules/categories'
import docs from 'src/vuex/modules/docs'
import eventsSpecifications from './modules/eventsSpecifications'
import gallery from './modules/gallery'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    executing: false,
    user: {},
    config: {},
    eventSelected: {},
    rangeDate: '',
    apis: {
      edu: {
        events: [],
        speeches: [],
        eventsCount: 0,
        speechesCount: 0,
        loading: false
      }
    }
  },
  mutations: {
    SET_EVENTS_EDU_COUNT: (state, payload) => {
      state.apis.edu.eventsCount = payload
    },
    SET_EVENTS_EDU_API: (state, payload) => {
      state.apis.edu.events = payload
    },
    SET_SPEECHES_EDU_API: (state, payload) => {
      state.apis.edu.speeches = payload
    },
    SET_SPEECHES_EDU_COUNT: (state, payload) => {
      state.apis.edu.speechesCount = payload
    },
    SET_EDU_COUNT_LOADING: (state, payload) => {
      state.apis.edu.loading = payload
    },
    changeStateExecution: (state, payload) => {
      state.executing = payload
    },
    changeUser: (state, payload) => {
      state.user = payload
    },
    changeConfig: (state, payload) => {
      state.config = payload
    },
    changeEventSelected: (state, payload) => {
      state.eventSelected = payload
    },
    changeRangeDate: (state, payload) => {
      state.rangeDate = payload
    }
  },
  actions: {
    setDatasApiEdu: (context, { events, speeches, loading }) => {
      if (loading !== undefined) context.commit('SET_EDU_COUNT_LOADING', loading)
      if (events !== undefined) {
        context.commit('SET_EVENTS_EDU_API', events)
        context.commit('SET_EVENTS_EDU_COUNT', events.length)
      }
      if (speeches !== undefined) {
        context.commit('SET_SPEECHES_EDU_API', speeches)
        context.commit('SET_SPEECHES_EDU_COUNT', speeches.length)
      }
    },
    changeExecution: (context, payload) => context.commit('changeStateExecution', payload),
    changeRange: (context, payload) => {
      if (!payload) payload = []
      if (payload.length > 0 && payload[0] instanceof Date && payload[1] instanceof Date) {
        payload[0] = payload[0].toString()
        payload[1] = payload[1].toString()
      }
      context.commit('changeRangeDate', payload)
    },
    setUser: async (context, payload) => {
      if (payload && payload.role && payload.role !== '') {
        const couchRoles = new CouchdbClass({connection: 'config', collection: 'roles'})
        let p = await couchRoles.where('name', payload.role).first()
        payload.permissions = p ? p.permissions : p
      }
      localStorage.setItem('user', JSON.stringify(payload))
      context.commit('changeUser', payload)
    },
    unsetUser: (context, payload) => {
      localStorage.removeItem('user')
      context.commit('changeUser', {})
    },
    setConfig: (context, payload) => {
      Couchdb.collection('projects').find('config').then(result => {
        localStorage.setItem('config', JSON.stringify(result))
        context.commit('changeConfig', result)
      }).catch(err => console.log(err))
    },
    setEventSelected: (context, eventId) => {
      if (eventId === '') {
        localStorage.setItem('eventSelected', JSON.stringify({}))
        context.commit('changeEventSelected', {})
      } else {
        Couchdb.collection('events').find(eventId).then(result => {
          localStorage.setItem('eventSelected', JSON.stringify(result))
          context.commit('changeEventSelected', result)
        }).catch(err => console.log(err))
      }
    }
  },
  getters: {
    user: state => Object.assign(state.user, JSON.parse(localStorage.getItem('user'))),
    config: state => Object.assign(state.config, JSON.parse(localStorage.getItem('config'))),
    eventSelected: state => Object.assign(state.eventSelected, JSON.parse(localStorage.getItem('eventSelected'))),
    rangeDate: state => Object.assign(state.rangeDate, JSON.parse(localStorage.getItem('rangeDate'))),
    formatedDate: state => {
      let formatedDate = []
      if (state.rangeDate && state.rangeDate.length > 0) {
        formatedDate.push(
          new Date(state.rangeDate[0]).toISOString().replace('03:00:00', '00:00:00')
        )
        formatedDate.push(
          new Date(state.rangeDate[1]).toISOString().replace('03:00:00', '23:59:59')
        )
      }
      return formatedDate
    },
    apiEdu: state => state.apis.edu
  },
  modules: {
    users: Users,
    events: Events,
    customers: Customers,
    project: Project,
    manufacturers: Manufacturers,
    stocks: Stocks,
    lamps: Lamps,
    tickets: Tickets,
    states: States,
    roles: Roles,
    winners: Winners,
    surveys: Surveys,
    ranking: Ranking,
    tags: Tags,
    api: Api,
    docs,
    categories,
    eventsSpecifications,
    gallery
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js